import { useTexts } from "Components/TextContext";
import React from "react";

export const LinkToHuseierne = (): React.ReactElement => {
  const { createLinkComponent } = useTexts();
  return (
    <p>
      {createLinkComponent(
        "partnerhuseierne.link.huseierne",
        {
          variables: {
            huseierne_link: {
              url: "https://www.huseierne.no/",
              text: "huseierne.no",
              __type: "hyperlink",
            },
          },
        },
        false,
      )}
    </p>
  );
};
